import React, { createContext, PropsWithChildren } from 'react';
import { configure } from 'mobx';

import GlobalStore from './GlobalStore';

configure({ enforceActions: 'observed' });

const storeContext = createContext<GlobalStore | null>(null);
export const StoreProvider: React.FC<PropsWithChildren> = ({ children }) => (
  <storeContext.Provider value={new GlobalStore()}>{ children }</storeContext.Provider>
);

export const useGlobalStore = () => {
  const store = React.useContext(storeContext);
  if (store == null) {
    throw new Error('Missing global store!');
  }

  return store;
};
